import React, { PureComponent } from 'react';
import { func } from 'prop-types';
import InsuranceCard from './InsuranceCard';
import InsuranceCardShape from '../../shapes/InsuranceCard';
import { ImageType } from '../../sagas/images';

type OwnProps = {
  // @ts-expect-error ts-migrate(2749) FIXME: 'InsuranceCardShape' refers to a value, but is bei... Remove this comment to see the full error message
  insuranceCard?: InsuranceCardShape;
  // @ts-expect-error ts-migrate(2749) FIXME: 'func' refers to a value, but is being used as a t... Remove this comment to see the full error message
  onClickFront?: func;
  // @ts-expect-error ts-migrate(2749) FIXME: 'func' refers to a value, but is being used as a t... Remove this comment to see the full error message
  onClickBack?: func;
  // @ts-expect-error ts-migrate(2749) FIXME: 'func' refers to a value, but is being used as a t... Remove this comment to see the full error message
  handleFileChange: func;
};

type Props = OwnProps & typeof InsuranceUploader.defaultProps;

export default class InsuranceUploader extends PureComponent<Props> {
  static defaultProps = {
    insuranceCard: {
      front: {},
      back: {},
    },
  };

  render = () => {
    const { insuranceCard, onClickBack, onClickFront, handleFileChange } = this.props;

    return (
      <>
        <InsuranceCard
          cardImage={insuranceCard.front.base64}
          handleFileChange={handleFileChange(ImageType.DentalInsuranceFront)}
          onClick={onClickFront}
          scanCompleted={insuranceCard.front.scanCompleted}
          scanStarted={insuranceCard.front.scanStarted}
          showPlaceholder
        >
          Scan front of card
        </InsuranceCard>

        <InsuranceCard
          cardImage={insuranceCard.back.base64}
          handleFileChange={handleFileChange(ImageType.DentalInsuranceBack)}
          onClick={onClickBack}
          scanCompleted={insuranceCard.back.scanCompleted}
          scanStarted={insuranceCard.back.scanStarted}
          showPlaceholder={!!insuranceCard.front.base64}
        >
          Scan back of card
        </InsuranceCard>
      </>
    );
  };
}
